import { makeStyles } from "@material-ui/core";

export const principalPanelStyles = makeStyles(theme => ({
    paper: {

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%', // Fix IE 11 issue.
      //marginTop: 1,
      backgroundColor: "#2e2757",
      // padding: "1% 6% 6% 6%",
      // borderRadius: "8px",
      //border: "3px solid #EEEFF2"
    },
    avatar: {
      margin: 1,
      backgroundColor: 'red',
    },
    button_pp: {
      backgroundImage: `url(${process.env.PUBLIC_URL + '/images/Recurso 10@2x.png'})`,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      //marginTop: 1,
    },
    imagesCarousel: {
      [theme.breakpoints.up('xs')]: {
        width: `100vw`,
        height: `100%`,

      },
      [theme.breakpoints.up('sm')]: {
        maxWidth: `100%`,
        maxHeight: `100%`,

      },
      [theme.breakpoints.up('md')]: {
        maxWidth: `100%`,
        maxHeight: `100%`,

      },
      [theme.breakpoints.up('lg')]: {
        maxWidth: `100%`,
        maxHeight: `100%`,

      },
      [theme.breakpoints.up('xl')]: {
        maxWidth: `100%`,
        maxHeight: `100%`,

      }
    },
    Carousel: {
      "&:.Carousel-active-28": {
        color: "#0097a0"
      },
      /* width: '100%',
      margin:'10px',
      marginTop:'20px' */
      /* [theme.breakpoints.up('xs')]: {
        maxHeight: "100vh",
        height: "55vh"
      },
      [theme.breakpoints.up('sm')]: {
        maxHeight: "100vh",
        height: "100%"
      },
      [theme.breakpoints.up('md')]: {
        maxHeight: "100vh",
        height: "100%"
      },
      [theme.breakpoints.up('lg')]: {
        maxHeight: "100vh",
        height: "100%"
      },
      [theme.breakpoints.up('xl')]: {
        maxHeight: "100vh",
        height: "100%"
      } */
    },
    submit: {
      margin: (3, 0, 2),
      fontWeight: 'bold',
      fontSize: '0.9rem',
      color: 'white',
      backgroundColor: "#0097a0",
      "&:hover": {
        backgroundColor: "#0097a0"
      },
      borderRadius: "8px",
      border: "1px solid #fffffe"
    },
    logo: {
      width: '40%',
      height: '40%'
    },
    footer: {
      width: '5%',
      height: '5%'
    },
    button_header: {
      marginTop: 5,
    },
    grid_header: {
      marginTop: 5,
    },
    copyright: {
      justifyContent: 'space-between'
    },
    multilineColor:{
      color:'red'
    },
    root: {
      background: "red"
    },
    input: {
      color: "white"
    },
    title: {
      color: 'rgb(0, 0, 1)',
      fontWeight: 'bold',
      fontSize: '1.75rem'
    },
    button: {
      fontSize: '0.875rem',
      color: 'white',
      background: '#0097a0',
      "&:hover": {
        backgroundColor: "#0097a0"
      },
      borderRadius: "8px",
      border: "1px solid #fffffe"
    },
    buttonPrincipalPrimary: {
      minWidth: '80px',
      //maxWidth: '110px',
      width: '100%'
    },
    buttonPrincipalSecundary: {
      minWidth: '55px',
      //maxWidth: '82px',
      width: '100%'
    },
    divStandard: {
      paddingTop: "10px",
      paddingBottom: "20px",
      //border: '2px solid #BEBCC0',
      /* border: '2px solid #BEBCC0',
       */
      borderRadius: "16px",
      backgroundColor: "#efefef"
      //// boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
    },

  }))
